import { Modal, Toast } from 'shared/ui'
import { IdleManager } from 'entities/Auth/ui/IdleManager'
import { PresentationMode } from 'widgets/PresentationMode/ui/PresentationMode'
import { GlobalEvents } from 'app/shared/ui/GlobalEvents'

const OverlayLayout = () => {
  return (
    <>
      <Modal />
      <PresentationMode />
      <Toast />
      <GlobalEvents />
      <IdleManager />
    </>
  )
}

export default OverlayLayout
